<template>
  <div>
    <el-card class="prodinfo--card">
      <z-search :configs="configs" :showNumCheck="false" v-model="searchData" ref="search" @do-query="query"></z-search>
    </el-card>
    <el-card style="margin-top: 10px">
      <div class="prodstock--list__total">
        {{ $t('storage::commodity-stocks:total_stock') }}： {{ allStock }}
        <span style="margin-left: 5px">
          {{ $t('storage::commodity-stocks:total_stock_amount') }}： ￥{{ allValuation }}
        </span>
      </div>
      <div class="prodstock--list__tips" v-show="tableSelections.length">
        <span>
          {{ $t('storage::commodity-stocks::selected') }} {{ tableSelections.length }}
          {{ $t('storage::commodity-stocks::item') }}
        </span>
        |
        <span>{{ $t('storage::commodity-stocks::platform_table_use_stock') }}：{{ totalAvailableInventory || 0 }}</span>
        <span>{{ $t('storage::commodity-stocks::platform_table_commodity_stock') }}：{{ totalProductStock || 0 }}</span>
        <span>{{ $t('storage::commodity-stocks::platform_total_stock') }}：{{ totalvaluation || 0 }}</span>
      </div>
      <z-table
        :columns="tableColumns"
        :data="tableData"
        :max-height="550"
        v-loading="loading"
        @selection-change="handleSelectTable"
        :pagination.sync="pagination"
        class="prodstock--table"
        @page-change="handlePageChange"
      >
        <template #sku="{ row }">
          <div style="width: 100%; cursor: pointer" @click="showInventoryList(row)">
            <div class="prodstock--table__imgTd" style="line-height: 0">
              <el-popover placement="top-start" trigger="hover" style="margin-right: 10px">
                <ZImg :src="row.imageUrl" style="width: 250px; height: 250px"></ZImg>
                <ZImg :src="row.imageUrl" style="width: 64px; height: 64px" slot="reference"></ZImg>
              </el-popover>
              <div style="display: flex; flex-direction: column">
                <div class="prodstock--table__name">
                  {{ row.productName ? row.productName + '-' : '' }}{{ row.optionValueNames }}
                </div>
                <div class="prodstock--table__spu">
                  SPU: {{ row.spu }}{{ row.productCategory ? ' | ' + row.productCategory : '' }}
                </div>
                <div class="prodstock--table__sku">SKU: {{ row.sku }}</div>
              </div>
            </div>
          </div>
        </template>
        <template #supplyCost="{ row }">
          <span v-if="row.supplyCost">{{ $dataCheck(row.supplyCost, '--') }}</span>
          <span v-else>--</span>
        </template>
        <template #supplyCostHeader>
          <div>
            {{ $t('storage::commodity-stocks::platform_table_pat_cost') }}
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                {{ $t('storage::commodity-stocks::platform_table_pat_cost_tips1') }}，
                <br />
                {{ $t('storage::commodity-stocks::platform_table_pat_cost_tips2') }}
              </div>
              <i class="icon-a-01wenhao iconfont-el" style="font-size: 14px"></i>
            </el-tooltip>
          </div>
        </template>
        <template #valuationStockHeader>
          <div>
            {{ $t('storage::commodity-stocks::platform_table_stock_amount') }}
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                {{ $t('storage::commodity-stocks::platform_table_stock_equal') }}
              </div>
              <i class="icon-a-01wenhao iconfont-el" style="font-size: 14px"></i>
            </el-tooltip>
          </div>
        </template>
        <template #stock="{ row }">
          <div>
            {{ $t('storage::commodity-stocks::platform_table_use_stock') }}: {{ $dataCheck(row.usedStock, '--') }}
          </div>
          <div>
            {{ $t('storage::commodity-stocks::platform_table_commodity_stock') }}:
            <span :style="`color:${compareCount(row.productStock, row.safeStock)}`">
              {{ $dataCheck(row.productStock, '--') }}
            </span>
          </div>
          <div>
            {{ $t('storage::commodity-stocks::platform_table_safe_stock') }}: {{ $dataCheck(row.safeStock, '--') }}
          </div>
        </template>
        <template #valuationStock="{ row }">
          <div>{{ $dataCheck(row.valuationStock, '--') }}</div>
        </template>
      </z-table>
    </el-card>
    <stockFlow v-model="isShowStockFlow" @closeDialog="closeDialog" :sku="selectSku"></stockFlow>
  </div>
</template>

<script>
import { getStockTable, getSupplierList, getStockCount } from '@/server/data'
import stockFlow from './stockFlow'
import { STOCKS_COLUMNS, searchConfig } from '../config'
export default {
  components: {
    stockFlow,
  },
  data() {
    return {
      allStock: 0,
      allValuation: 0,
      configs: searchConfig(),
      searchData: {
        filterObj: '1',
      },
      tableColumns: STOCKS_COLUMNS,
      tableSelections: [],
      totalAvailableInventory: 0,
      totalProductStock: 0,
      totalvaluation: 0,
      loading: false,
      isShowStockFlow: false,
      selectSku: {},
      tableData: [],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0,
      },
    }
  },
  mounted() {
    this.getSearchConfig()
    this.getStockCount()
    this.handlePageChange()
  },
  activated() {},
  methods: {
    showInventoryList(sku) {
      this.selectSku = sku
      this.isShowStockFlow = true
    },
    async getStockCount(d) {
      let search = {}
      if (d && d.filterObj && d.value) {
        search = {
          searchType: d.filterObj,
          searchValue: d.value,
        }
      }
      let params = {
        ...d,
        ...search,
      }
      delete params.filterObj
      delete params.value
      const { data } = await getStockCount(params)
      if (data.code === this.$code) {
        this.allStock = data.data.datas[0].productStock || 0
        this.allValuation = data.data.datas[0].totalValuationStock || 0
      }
    },
    async getSearchConfig() {
      this.configs = searchConfig([])
      const supplier = await getSupplierList()
      let list = supplier.data.data.datas.map(item => {
        return { label: item.supplierName, value: item.supplierId }
      })
      this.configs = searchConfig(list)
    },
    async getTableData(d) {
      let search = {}
      if (d && d.filterObj && d.value) {
        search = {
          searchType: d.filterObj,
          searchValue: d.value,
        }
      }
      let params = {
        pageInfo: {
          ...this.pagination,
        },
        ...d,
        ...search,
      }
      delete params.filterObj
      delete params.value
      delete params.pageInfo.total
      this.loading = true
      const { data } = await getStockTable(params)
      if (data.code === this.$code) {
        this.tableData = data.data.datas
        this.pagination.total = data.data.total
      }
      this.loading = false
    },
    query(data) {
      this.pagination.pageNum = 1
      this.getTableData(data)
      this.getStockCount(data)
    },
    handlePageChange() {
      this.$nextTick(() => {
        const params = this.$refs.search.getSearchParams()
        this.getTableData(params)
      })
    },
    compareCount(target1, target2) {
      if (target1 > target2) {
        return '#67C23A'
      } else if (target1 < target2) {
        return '#ff3c2a'
      } else {
        return 'inheirt'
      }
    },
    handleSelectTable(selection) {
      this.tableSelections = selection
      this.totalAvailableInventory = 0
      this.totalProductStock = 0
      this.totalvaluation = 0
      if (selection.length !== 0) {
        selection.forEach(item => {
          this.totalAvailableInventory += Number(item.usedStock)
          this.totalProductStock += Number(item.productStock)
          this.totalvaluation += Number(item.valuationStock)
        })
      } else {
        this.totalAvailableInventory = 0
        this.totalProductStock = 0
        this.totalvaluation = 0
      }
    },
    closeDialog() {
      this.isShowStockFlow = false
    },
  },
}
</script>

<style lang="scss" scoped>
.prodinfo--list {
  &__btnWrap {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
  }
}
.prodstock--table {
  &__imgTd {
    display: flex;
    align-items: center;
    // height: 110px;
    padding: 24px 0;
  }
  &__name {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #010517;
    line-height: 19px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 160px;
  }
  &__spu {
    font-size: 12px;
    color: #666666;
    line-height: 16px;
    margin: 9px 0 3px 0;
  }
  &__sku {
    font-size: 12px;
    color: #666666;
    line-height: 16px;
  }
  /deep/ .el-table td {
    padding: 0;
  }
  .tag-wrap {
    display: flex;
    align-items: center;
  }
}

.prodstock--list {
  &__total {
    font-family: MicrosoftYaHei;
    color: #010517;
    line-height: 21px;
    font-size: 16px;
    margin-bottom: 16px;
  }
  &__tips {
    font-family: MicrosoftYaHei;
    height: 40px;
    background: #f9fbff;
    border: 1px solid #bad1ff;
    font-size: 14px;
    color: #010517;
    line-height: 40px;
    padding-left: 16px;
    margin-bottom: 19px;
  }
}
</style>
